<template>
  <div class="layout">
    <dx-drawer
      position="before"
      template="menu"
      :opened.sync="menuOpened"
      :opened-state-mode="drawerOptions.menuMode"
      :reveal-mode="drawerOptions.menuRevealMode"
      :min-size="drawerOptions.minMenuSize"
      :shading="drawerOptions.shaderEnabled"
      :close-on-outside-click="drawerOptions.closeOnOutsideClick"
      :element-attr="{
        id: 'gc-main-layout-drawer',
        class: 'drawer gc-main-layout-drawer drawer-v2',
      }"
      :max-size="200"
    >
      <div class="container" id="container-wrapper">
        <gc-header-toolbar
          :menu-toggle-enabled="headerMenuTogglerEnabled"
          :toggle-menu-func="toggleMenu"
          :baseView="baseView"
          :selectedIndex="selectedIndex"
          :tabs="tabs"
          :isXSmall="isXSmall"
          :isLarge="isLarge"
          :back-button-enabled="backButtonEnable"
          :backButtonFunc="backButtonFunction"
          :ref="'headertoolbar'"
        >
          <template v-slot:headerContent="slotProps">
            <slot name="headerContent" :baseView="slotProps.baseView" />
          </template>
        </gc-header-toolbar>

        <dx-scroll-view ref="scrollViewRef" class="layout-body with-footer">
          <div class="content" :ref="'containerwrapper'">
            <slot />
            <GcPopupValidationSummary
              v-if="formsConfig"
              :showPopup.sync="formsConfig.validationSummaryVisible"
              :validation-group="formsConfig.validationGroup"
              :title="'Validation Errors'"
              :isXSmall="isXSmall"
              :items.sync="formsConfig.items"
            ></GcPopupValidationSummary>
            <GcPopupValidationSummary
              v-if="formsConfig"
              :showPopup.sync="formsConfig.serverValidationSummaryVisible"
              :title="'Server Error'"
              :isXSmall="isXSmall"
              :items.sync="formsConfig.serverItems"
            ></GcPopupValidationSummary>
            <GcPopupValidationSummary
              v-if="formsConfig"
              :showPopup.sync="formsConfig.customValidationSummaryVisible"
              :title="'Validation Errors'"
              :isXSmall="isXSmall"
              :items.sync="formsConfig.items"
            ></GcPopupValidationSummary>
            <DxLoadPanel
              v-if="formsConfig"
              :position="loadingPosition"
              :visible.sync="formsConfig.loadingVisible"
              :show-indicator="true"
              :show-pane="true"
              :shading="true"
              :hide-on-outside-click="false"
              shading-color="rgba(0,0,0,0)"
            />

            <Keypress
              key-event="keyup"
              @success="keyUp"
              :multiple-keys="multiple"
            />

            <GcPopupAlert
              v-if="formsConfig"
              :showPopupAlert.sync="formsConfig.popupAlertVisible"
              :title="''"
              :isXSmall="isXSmall"
              :message.sync="formsConfig.popupAlertMessage"
            ></GcPopupAlert>

            <GcPopupAudit
              v-if="formsConfig"
              :showPopup.sync="formsConfig.popupAuditVisible"
              :model.sync="formsConfig.auditModel"
            />
          </div>
        </dx-scroll-view>
        <div class="gc-footer">
          <slot name="footer" />
        </div>
      </div>
      <!-- eslint-disable vue/no-unused-vars -->
      <gc-side-nav-menu
        slot="menu"
        slot-scope="_"
        class="dx-swatch-additional"
        :compact-mode="!menuOpened"
        :items="menuItems"
        @click="handleSideBarClick"
      >
        <!-- eslint-enable-->
        <dx-toolbar
          id="navigation-header"
          v-bind:class="[
            tabs.length != 0 && !isXSmall
              ? 'header-toolbar-with-tabs'
              : 'header-toolbar-no-tabs',
          ]"
        >
          <dx-item v-if="!isXSmall" location="before" css-class="menu-button">
            <!-- eslint-disable vue/no-unused-vars -->
            <dx-button
              icon="menu"
              styling-mode="text"
              @click="toggleMenu"
              slot-scope="_"
            />
            <!-- eslint-enable -->
          </dx-item>
          <dx-item location="before" css-class="header-title dx-toolbar-label">
            <!-- eslint-disable vue/no-unused-vars -->
            <div slot-scope="_">
              <!-- <div>{{ title }} AA</div> -->
              <img :src="imgUrl" style="width: 150px" />
            </div>
            <!-- eslint-enable -->
          </dx-item>
        </dx-toolbar>
      </gc-side-nav-menu>
    </dx-drawer>
  </div>
</template>

<script>
import { DxLoadPanel } from "devextreme-vue/load-panel";
// eslint-disable-next-line no-unused-vars
import { NavigationStorage } from "../../_services/storage";
import { mapGetters } from "vuex";
import Keypress from "vue-keypress";

function removeIconProperty(obj) {
  for (let prop in obj) {
    if (prop === "icon") delete obj[prop];
    else if (typeof obj[prop] === "object") removeIconProperty(obj[prop]);
  }
}

export default {
  props: {
    title: String,
    isXSmall: Boolean,
    isLarge: Boolean,
    selectedIndex: Number,
    baseView: Object,
    backButtonEnable: Boolean,
    hotKeyGridTabIndex: {
      type: Number,
      default: function () {
        return 0;
      },
    },
    hotKeyCreatePath: {
      type: String,
      default: function () {
        return null;
      },
    },
    hasAutoComp: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hotKeyCreateRouteId: {
      type: String,
      default: function () {
        return null;
      },
    },
    tabs: {
      type: Array,
      default: function () {
        return [];
      },
    },
    formsConfig: {
      type: Object,
      default: function () {
        return null;
      },
    },
    backButtonFunction: {
      type: Function,
      default: function () {
        return null;
      },
    },
    hotKeyExpand: {
      type: Function,
      default: function () {
        return null;
      },
    },
    sprocketRelativeId: {
      type: String,
      default: function () {
        return "#container-wrapper";
      },
    },
  },
  methods: {
    keyUp(response) {
      if (
        response.event.altKey &&
        response.event.code === `KeyN` &&
        this.hotKeyCreatePath
      ) {
        this.$logger.trackEventShortcutKey("Add New");

        if (this.hotKeyCreateRouteId) {
          var newUrl = `${this.hotKeyCreatePath.substring(
            0,
            this.hotKeyCreatePath.lastIndexOf("/")
          )}/${this.hotKeyCreateRouteId}`;

          this.$router.push({
            path: "/redirect",
            query: { url: newUrl },
          });
        } else {
          this.$router.push({
            path: "/redirect",
            query: { url: this.hotKeyCreatePath },
          });
        }
      }
      if (response.event.altKey && response.event.code === `KeyG`) {
        this.$logger.trackEventShortcutKey("Focus First Editable Cell");
        if (this.selectedIndex == this.hotKeyGridTabIndex) {
          this.selectCell();
        } else {
          let tab = document.querySelector(".dx-tabs");
          if (tab) {
            let tabPage =
              tab.querySelectorAll(".dx-tab")[this.hotKeyGridTabIndex];
            tabPage.click();
          }
          setTimeout(this.selectCell, 700);
        }
      }
      if (response.event.altKey && response.event.code === "KeyS") {
        this.$logger.trackEventShortcutKey("Focus Grid Search");
        if (this.hotKeyGridTabIndex == -1) return;

        if (this.selectedIndex == this.hotKeyGridTabIndex)
          this.focusSearchPanel();
        else {
          let tab = document.querySelector(".dx-tabs");
          if (tab) {
            let tabPage =
              tab.querySelectorAll(".dx-tab")[this.hotKeyGridTabIndex];
            tabPage.click();
          }

          setTimeout(this.focusSearchPanel, 700);
        }
      }
      if (response.event.altKey && response.event.code === "KeyX") {
        this.$logger.trackEventShortcutKey("Expand/Collapse Grid");
        this.hotKeyExpand();
      }
    },
    focusSearchPanel() {
      {
        let searchPanel = document.querySelector(".dx-datagrid-search-panel");
        let searchPanelEditor = searchPanel.querySelector(
          ".dx-texteditor-input"
        );
        searchPanelEditor.focus();
        searchPanelEditor.select();

        // eslint-disable-next-line no-debugger
        // debugger;
      }
    },
    selectCell() {
      {
        let cells = document.querySelectorAll(
          ".gc-editor-cell:not([role='columnheader'])"
        );

        if (this.hasAutoComp) {
          let autoComp = document.querySelector(".gc-auto-cmp");
          if (autoComp) autoComp.click();
          return;
        }
        if (cells) {
          for (let i = 0; i < cells.length; i++) {
            let cell = cells[i];
            let inp = cell.querySelector(
              ".dx-texteditor-input-container input:not([disabled])"
            );
            let chk = cell.querySelector(
              ".dx-checkbox:not(.dx-state-readonly)"
            );
            if (inp || chk) {
              if (chk) {
                chk.focus();
              } else {
                cell.click();
                inp.focus();
                inp.select();
              }
              break;
            }
          }
        }
      }
    },
    async changeRoute() {
      this.ignoreRouteChange();
      this.$router.push({
        path: "/sales-order/edit/10224/details",
      });
      this.$logger.debug("blah 2");
    },
    toggleMenu(e) {
      const pointerEvent = e.event;
      pointerEvent.stopPropagation();
      if (this.menuOpened) {
        this.menuTemporaryOpened = false;
      }
      this.menuOpened = !this.menuOpened;
    },
    handleSideBarClick() {
      if (this.menuOpened === false) this.menuTemporaryOpened = true;
      this.menuOpened = true;
    },
    handleResize() {
      this.$store.dispatch(
        "ui/headerHeight",
        this.$refs["headertoolbar"].$el.clientHeight
      );
      this.$store.dispatch(
        "ui/viewHeight",
        this.$refs["scrollViewRef"].$el.clientHeight
      );

      setTimeout(() => {
        if (this.formsConfig)
          this.formsConfig.gridNoDataRecall(this.formsConfig.dataGridForNoData);
      }, 1000);
    },
  },
  data() {
    return {
      menuOpened: false,
      menuTemporaryOpened: false,
      menuItemsToFilter: [],
      loadingPosition: { of: this.sprocketRelativeId },
    };
  },
  created() {
    this.menuItemsToFilter = NavigationStorage.getItems();
    window.addEventListener("resize", this.handleResize);
    this.$logger.debug(this.baseView, "baseView");
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  beforeMount() {
    let globalCss = document.querySelector("#global-css");
    if (globalCss) globalCss.setAttribute("media", "");

    let salesCss = document.querySelector("#sales-css");
    if (salesCss) salesCss.setAttribute("media", "");
  },
  mounted() {
    this.handleResize();
  },
  computed: {
    ...mapGetters({ getHotKeyCreateNew: "hotKey/getHotKeyCreateNew" }),
    imgUrl() {
      let baseUrl = process.env.VUE_APP_BASE_URL;
      if (baseUrl === "/") return `${baseUrl}statics/GCORP-CX.png`;
      else return `/${baseUrl}/statics/GCORP-CX.png`;
    },
    ...mapGetters({ applicationMode: "profile/applicationMode" }),
    drawerOptions() {
      const shaderEnabled = !this.isLarge;
      return {
        menuMode: this.isLarge ? "shrink" : "overlap",
        menuRevealMode: this.isXSmall ? "slide" : "expand",
        minMenuSize: this.isXSmall ? 0 : 40,
        menuOpened: this.isLarge,
        hideOnOutsideClick: shaderEnabled,
        shaderEnabled,
      };
    },
    headerMenuTogglerEnabled() {
      return this.isXSmall;
    },
    multiple() {
      return [
        {
          keyCode: 78, // N
          modifiers: ["altKey"],
          preventDefault: true,
        },
        {
          keyCode: 71, // G
          modifiers: ["altKey"],
          preventDefault: true,
        },
        {
          keyCode: 83, // S
          modifiers: ["altKey"],
          preventDefault: true,
        },
        {
          keyCode: 88, // X
          modifiers: ["altKey"],
          preventDefault: true,
        },
      ];
    },
    scrollView() {
      return this.$refs["scrollViewRef"].instance;
    },
    menuItems() {
      // eslint-disable-next-line no-console
      this.$logger.debug("isXSmall", this.isXSmall);

      if (this.isXSmall === true) {
        removeIconProperty(this.menuItemsToFilter);
      }
      return this.menuItemsToFilter;
    },
  },
  watch: {
    getHotKeyCreateNew(value) {
      if (value) {
        this.$store.dispatch("hotKey/setHotKeyCreateNew", false);

        if (this.baseView.mode != "review" && !this.baseView.id) return;

        var route = undefined;
        var key = `/${this.baseView.view}/create`;
        const id = this.baseView.id;
        this.$router.options.routes.forEach((element) => {
          if (element.path.match(new RegExp(key))) {
            route = element;
          }
        });
        if (route) {
          this.setIgnoreRouteChangeConfirmation();
          this.$router
            .push({
              path: route.path.replace("*", ""),
              query: {},
            })
            .then(() => {
              if (id) {
                location.reload();
              }
            });
        }
      }
    },
    isLarge() {
      if (!this.menuTemporaryOpened) {
        this.menuOpened = this.isLarge;
      }
    },
    isXSmall(value) {
      if (value)
        this.$store.dispatch("profile/setApplicationMode", "GcorpRoam");
      else this.$store.dispatch("profile/setApplicationMode", "Gcorp");
    },
    $route() {
      if (this.menuTemporaryOpened || !this.isLarge) {
        this.menuOpened = false;
        this.menuTemporaryOpened = false;
      }
      this.scrollView.scrollTo(0);
    },
    applicationMode(mode) {
      this.$logger.info(`Application Mode:  ${mode}`);
      this.menuItemsToFilter = NavigationStorage.getItems();
      // eslint-disable-next-line no-console
      this.$logger.debug(this.menuItemsToFilter);
    },
    menuOpened() {
      setTimeout(() => {
        if (this.formsConfig)
          this.formsConfig.gridNoDataRecall(this.formsConfig.dataGridForNoData);
      }, 1000);
    },
  },
  components: {
    DxLoadPanel,
    Keypress,
  },
};
</script>

<style lang="scss">
// @import "../assets/styles/global.scss";

.layout {
  width: 100%;
}

.container {
  height: 100%;
  flex-direction: column;
  display: flex;
}

.layout-body {
  flex: 1;
  min-height: 0;
}

.content {
  flex-grow: 1;
}

#navigation-header {
  @import "../../assets/styles/variables.additional.scss";
  background-color: $base-accent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .menu-button .dx-icon {
    color: $base-text-color;
  }

  .screen-x-small & {
    padding-left: 20px;
  }

  .dx-theme-generic & {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .header-title {
    img {
      width: 100px !important;
    }
  }
}
</style>
